import { Spinner } from '@/components/glitch-ui/spinner';

interface LoadingStateProps {
  message: string;
}

export function CampaignGoalLoadingState({ message }: LoadingStateProps) {
  return (
    <div className='flex flex-row items-center justify-center py-2 space-y-2 text-muted-foreground'>
      <Spinner size="xl" />
      <p className='ml-10 text-[#290BD9]'>{message}</p>
    </div>
  );
}
